import { compose, withStateHandlers } from 'recompose'
import OptionsDropdown from './OptionsDropdown'

const withOptionsDropdownStateHandlers = withStateHandlers(
  { isOpen: false },
  { toggleHideShowDropdown: ({ isOpen }) => () => ({ isOpen: !isOpen }) }
)

export default compose(
  withOptionsDropdownStateHandlers
)(OptionsDropdown)
